import { Controller } from "@hotwired/stimulus"

// Nested form controller for dynamically adding/removing form rows
// Connects to data-controller="nested-form"
export default class extends Controller {
  static targets = ["container", "template"]

  add(e) {
    e.preventDefault()

    if (this.hasTemplateTarget) {
      const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
      this.containerTarget.insertAdjacentHTML("beforeend", content)
    }
  }

  remove(e) {
    e.preventDefault()

    const row = e.target.closest(".nested-fields")
    if (!row) return

    // If it has a hidden _destroy field, mark for destruction
    const destroyField = row.querySelector("input[name*='_destroy']")
    if (destroyField) {
      destroyField.value = "1"
      row.classList.add("hidden")
    } else {
      row.remove()
    }
  }
}
